import { ApiBaseService, ApiV2Service } from './api.base.service';
import store from '@/store/store';
import { Organisation, SuccessResponse, UploadImageUrlResponse } from '../types';

export class OrganisationService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async getOrganisations(): Promise<Organisation[]> {
    return this.api.get('user/organisations');
  }

  public async createOrganisation(details: any): Promise<Organisation> {
    const currentOrg = store.getters.activeOrganisation[0].id;
    return this.api.post(`organisation/${currentOrg}/organisation`, details);
  }

  public async updateOrganisation(id: number, payload: any): Promise<Organisation> {
    return this.api.put(`organisation/${id}`, payload);
  }

  public async uploadOrganisationLogo(id: number, file: Blob): Promise<void> {
    const urlResp = await this.api.get<UploadImageUrlResponse>(`organisation/${id}/logo-upload-url`);
    const data = urlResp.urlInfo;
    const formData = new FormData();
    // formData.append('Content-Type', file.type);
    Object.entries(data.fields).forEach(([k, v]) => {
      formData.append(k, (v as string));
    });
    formData.append('file', file);
    return this.api.postFormExt(data.url, formData);
  }

  public async removeOrganisationLogo(id: number): Promise<SuccessResponse> {
    return this.api.delete(`organisation/${id}/logo`);
  }

  public async terminateOrganisation(id: number, confirm: boolean): Promise<any> {
    return this.api.post(`admin/organisation/${id}/terminate?confirm=${confirm}`, {});
  }

}

export default new OrganisationService();
